import { i18n } from 'app/utils/i18n';

const Row = ({ label, value }) => (
  <li className="roll-forward__review-row">
    <span className="roll-forward__review-label">{label}</span>
    <span className="roll-forward__review-value">{value}</span>
  </li>
);

// Mirrors the legacy CloneDocumentModal checklist (reuses its i18n keys).
const CloneItem = ({ labelKey, type = 'success' }) => (
  <li className={`roll-forward__clone-item ${type === 'success' ? '' : 'text-gray-500'}`}>
    <i className={`fa-regular mr-2 ${type === 'success' ? 'fa-check text-success' : 'fa-xmark'}`} /> {i18n(labelKey)}
  </li>
);

const StepReview = ({ preview, periodOverrides, keepDismissals }) => {
  const editedCount = Object.keys(periodOverrides).length;
  return (
    <div className="roll-forward__step">
      <h4 className="roll-forward__heading">{i18n('roll-forward.step.review')}</h4>
      <ul className="roll-forward__review">
        <Row label={i18n('roll-forward.review.tags')} value={`${preview.tagCount} → ${i18n('roll-forward.review.need-attention')}`} />
        <Row label={i18n('roll-forward.review.validation')} value={i18n('roll-forward.review.unvalidated')} />
        <Row
          label={i18n('roll-forward.review.periods')}
          value={
            editedCount > 0 ? i18n('roll-forward.review.periods-edited').replace('{count}', String(editedCount)) : i18n('roll-forward.review.periods-unchanged')
          }
        />
        <Row
          label={i18n('roll-forward.review.dismissals')}
          value={keepDismissals ? i18n('roll-forward.review.dismissals-kept') : i18n('roll-forward.review.dismissals-dropped')}
        />
      </ul>

      <p className="roll-forward__clone-info">{i18n('project-details.clone.modal.info')}</p>
      <div className="row roll-forward__clone-checklist">
        <div className="col-sm-6">
          <ul className="roll-forward__clone-list">
            <CloneItem labelKey="project-details.clone.sections" />
            <CloneItem labelKey="project-details.clone.content" />
            <CloneItem labelKey="project-details.clone.data" />
            <CloneItem labelKey="project-details.clone.templates" />
          </ul>
        </div>
        <div className="col-sm-6">
          <ul className="roll-forward__clone-list">
            <CloneItem labelKey="project-details.clone.users" type="danger" />
            <CloneItem labelKey="project-details.clone.versions" type="danger" />
            <CloneItem labelKey="project-details.clone.comments" type="danger" />
          </ul>
        </div>
      </div>
    </div>
  );
};

export default StepReview;
